export const Marquee = ({ text = "Built With Intention. Created to Be Remembered." }) => {
  const items = Array.from({ length: 6 });
  return (
    <div data-testid="brand-marquee" className="overflow-hidden border-y border-line bg-ivory py-8 md:py-10" aria-label={text}>
      <div className="marquee-track flex w-max" aria-hidden>
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0">
            {items.map((_, i) => (
              <span key={i} className="flex items-center whitespace-nowrap font-serif text-3xl font-light italic text-wine md:text-5xl">
                <span className="px-8 md:px-12">{text}</span>
                <span className="text-champagne text-xl not-italic">◆</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
